import {createInteractionId} from '@servicenow/ui-metrics';
import getHostVariables from './getHostVariables';
import {ANCESTOR_ROOT_NODE, PREVIOUS_INTERACTION_ID} from '../symbols';

export default function resolveParentTraceId(host) {
	const variables = getHostVariables(host);

	if (variables[ANCESTOR_ROOT_NODE]) {
		const parentVariables = getHostVariables(variables[ANCESTOR_ROOT_NODE]);
		const interactionId = parentVariables[PREVIOUS_INTERACTION_ID];
		if (interactionId) {
			variables[PREVIOUS_INTERACTION_ID] = interactionId;
			return interactionId;
		}
	}

	const interactionId = createInteractionId();
	variables[PREVIOUS_INTERACTION_ID] = interactionId;
	return interactionId;
}
